import axios from '@/plugins/axios'

export default {
  fetch(params) {
    return axios.get('clients', { params }).then(result => result.data)
  },
  store(data) {
    return axios.post('clients', data).then(result => result.data)
  },
  update(id, data) {
    return axios.patch(`clients/${id}`, data).then(result => result.data)
  },
  get(id) {
    return axios.get(`clients/${id}`).then(result => result.data)
  },
  delete(id) {
    return axios.delete(`clients/${id}`).then(result => result.data)
  }
}
